module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('Header', {
    staticClass: "black"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('Footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "slogan"
  }, [_c('div', {
    staticClass: "h1"
  }, [_vm._v("打造视频梦工厂")]), _vm._v(" "), _c('div', {
    staticClass: "h2"
  }, [_vm._v("懂视频·更懂你")])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "about.html"
    }
  }, [_vm._v("关于我们")])]), _vm._v(" "), _c('span', {
    staticClass: "active"
  }, [_vm._v("服务流程")]), _vm._v(" "), _c('span', [_c('a', {
    attrs: {
      "href": "question.html"
    }
  }, [_vm._v("常见问题")])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "list clearfix"
  }, [_c('dl', [_c('dt', [_c('i', [_vm._v("01")])]), _vm._v(" "), _c('dd', [_c('div', {
    staticClass: "h1"
  }, [_vm._v("发布拍片需求")]), _vm._v(" "), _c('div', {
    staticClass: "summary"
  }, [_vm._v("填写需要制作的视频基本信息，包括视频类型、时长、项目预算等，提交需求后，客服会通过留下的联系方式与您联系。")])])]), _vm._v(" "), _c('dl', [_c('dt', [_c('i', [_vm._v("02")])]), _vm._v(" "), _c('dd', [_c('div', {
    staticClass: "h1"
  }, [_vm._v("沟通确认")]), _vm._v(" "), _c('div', {
    staticClass: "summary"
  }, [_vm._v("平台与用户线下联系，明确详细的制作需求。")])])]), _vm._v(" "), _c('dl', [_c('dt', [_c('i', [_vm._v("03")])]), _vm._v(" "), _c('dd', [_c('div', {
    staticClass: "h1"
  }, [_vm._v("签订合同")]), _vm._v(" "), _c('div', {
    staticClass: "summary"
  }, [_vm._v("根据与用户的沟通结果生成《项目概要》、《合同》，用户查看无异议后在趣编网上进行合同签署。")])])]), _vm._v(" "), _c('dl', [_c('dt', [_c('i', [_vm._v("04")])]), _vm._v(" "), _c('dd', [_c('div', {
    staticClass: "h1"
  }, [_vm._v("方案策划")]), _vm._v(" "), _c('div', {
    staticClass: "summary"
  }, [_vm._v("用户支付策划费用，策划人根据需求提供合适的策划案，用户查看无异议后在趣编网上进行确认。")])])]), _vm._v(" "), _c('dl', [_c('dt', [_c('i', [_vm._v("05")])]), _vm._v(" "), _c('dd', [_c('div', {
    staticClass: "h1"
  }, [_vm._v("拍摄制作")]), _vm._v(" "), _c('div', {
    staticClass: "summary"
  }, [_vm._v("用户支付拍摄费用，制作团队根据策划案拍摄制作，用户查看无异议后在趣编网上进行确认。在确认过程中，用户可以对视频提出三次修改要求，制作团队会根据用户需求进行相应的修改。")])])]), _vm._v(" "), _c('dl', [_c('dt', [_c('i', [_vm._v("06")])]), _vm._v(" "), _c('dd', [_c('div', {
    staticClass: "h1"
  }, [_vm._v("确认下载视频")]), _vm._v(" "), _c('div', {
    staticClass: "summary"
  }, [_vm._v("视频确认无异议后，用户支付项目尾款。支付成功后用户可以下载该视频，此项目完成。")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4795540c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/flow/App.vue
// module id = 1282
// module chunks = 17